// src/utils/toastService.js

let toastInstance = null;

/**
 * Ustawia instancję toastów.
 * Należy wywołać tę funkcję w głównym komponencie aplikacji, np. App.vue.
 *
 * @param {Object} instance - Instancja komponentu Toast.
 */
export function setToastInstance(instance) {
  toastInstance = instance;
}

/**
 * Wyświetla toast z podanymi parametrami.
 *
 * @param {Object} params - Parametry toastu.
 * @param {string} params.severity - Severity toastu (np. 'success', 'error').
 * @param {string} params.summary - Nagłówek toastu.
 * @param {string} params.detail - Szczegółowy komunikat toastu.
 * @param {number} [params.life=3000] - Czas trwania toastu w milisekundach.
 */
export function showToast({ severity, summary, detail, life = 3000 }) {
  if (toastInstance) {
    toastInstance.add({ severity, summary, detail, life });
  }
}
